import React, { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import api from "@/lib/api";
import { NumberOneShareButton } from "@/components/NumberOneShareButton";
import { BornNumberOne } from "@/components/BornNumberOne";

const ddmmToday = () => { const d = new Date(); return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}`; };
const dayLabel = () => new Date().toLocaleDateString("en-GB", { day: "numeric", month: "long" });

/** One No.1 per year for the current week in history — newest first — instead of every chart-topper ever. */
export const NumberOnesThisWeek = ({ chart, meta }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    api.get("/number-ones/this-week", { params: { date: ddmmToday(), chart } }).then((r) => setData(r.data)).catch(() => setData({ items: [] }));
  }, [chart]);
  if (!data) return <p className="mt-8 text-sm text-ink-muted">Loading this week's chart-toppers…</p>;
  if (data.items.length === 0) return <p data-testid="no1-week-empty" className="mt-8 text-sm text-ink-muted">No chart data for this week yet.</p>;
  return (
    <div className="mt-6" data-testid="no1-this-week">
      <BornNumberOne chart={chart} meta={meta} />
      <p className="mt-6 text-[12px] text-ink-muted inline-flex items-center gap-1.5" data-testid="no1-week-count"><CalendarDays className="w-3.5 h-3.5 text-gold" /> The {meta.region} No.1 {meta.kind} in the week of {dayLabel()}, every year back to {data.items[data.items.length - 1].year} — {data.items.length} years.</p>
      <ul className="mt-3 bg-white border border-[#e5e7eb] rounded-2xl divide-y divide-[#f1f5f9]">
        {data.items.map((n) => (
          <li key={n.year} data-testid={`no1-week-${n.year}`} className="flex items-center gap-4 px-4 py-3">
            <span className="w-14 shrink-0 text-[20px] font-bold text-gold leading-none">{n.year}</span>
            <div className="min-w-0 flex-1">
              <p className="text-[15px] font-bold text-ink leading-snug truncate">{n.title}</p>
              <p className="text-[13px] text-ink-muted truncate">{n.artist}{n.weeks_at_no1 ? ` · ${n.weeks_at_no1} wk${n.weeks_at_no1 === 1 ? "" : "s"} at No.1` : ""}</p>
            </div>
            <span className="hidden sm:block text-[11px] text-ink-muted shrink-0">{n.years_ago === 0 ? "this year" : `${n.years_ago} yr${n.years_ago === 1 ? "" : "s"} ago`}</span>
            <NumberOneShareButton item={n} greeting={`No.1 this week in ${n.year}`} testid={`no1-week-share-${n.year}`} />
          </li>
        ))}
      </ul>
    </div>
  );
};
